export default __webpack_public_path__ + "static/media/half-star@2x.4b638f06.png";